import { ReactNode } from 'react';
import BootstrapTab from 'react-bootstrap/Tab';

type TabsProps = {
  children: ReactNode;
  id?: string;
  activeTab?: string;
  defaultActiveTab?: string;
  mountOnEnter?: boolean;
  onSelect?: (eventKey: string) => void;
};

function Tabs({ children, id, activeTab, defaultActiveTab = '', onSelect, mountOnEnter }: TabsProps) {
  return (
    <BootstrapTab.Container
      id={id}
      activeKey={activeTab}
      defaultActiveKey={defaultActiveTab}
      onSelect={onSelect}
      mountOnEnter={mountOnEnter}
    >
      {children}
    </BootstrapTab.Container>
  );
}

export default Tabs;
